import React from "react";

const BasicDetailsSectionSkeleton = () => {
  return (
    <div className="dpl-patron-info ssc">
      <div className="dpl-patron-info__label">
        <div className="ssc-head-line w-10" />
      </div>
      <div className="dpl-patron-info__text">
        <div className="ssc-head-line w-20 mts" />
      </div>
      <div className="dpl-patron-info__label">
        <div className="ssc-head-line w-10" />
      </div>
      <div className="dpl-patron-info__text">
        <div className="ssc-head-line w-40 mts" />
      </div>
    </div>
  );
};

export default BasicDetailsSectionSkeleton;
